




























import { defineComponent } from '@nuxtjs/composition-api';
import { useFooter } from '@vue-storefront/novulo';

export default defineComponent({
  name: 'SocialLinks',
  setup() {
    const { footerResult } = useFooter();

    return {
      socialMedias: footerResult.value.footer_social_media || []
    };
  }
});
